import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { OnsetExamDataDto } from 'src/shared/dtos/onset-exam-data-dto';
import { OnsetExamResultDto } from 'src/shared/dtos/onset-exam-result-dto';
import { OnsetUserDto } from 'src/shared/dtos/onset-user-dto';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class IdasService {
    @Output() getOnsetExamDataCompleted: EventEmitter<OnsetExamDataDto> = new EventEmitter<OnsetUserDto>();
    @Output() postOnsetExamResultCompleted: EventEmitter<OnsetExamResultDto> = new EventEmitter<OnsetExamResultDto>();

    constructor(private httpClient: HttpClient) { }

    getOnsetExamData(token: string) {
        this.httpClient
            .get<OnsetExamDataDto>(environment.apiUrl + 'idas' + '/' + 'onset' + '/' + token)
            .subscribe((res: OnsetExamDataDto) => { this.getOnsetExamDataCompleted.emit(res); },
                (err: HttpErrorResponse) => {
                    console.log(err.error);
                    console.log(err.name);
                    console.log(err.message);
                    console.log(err.status);
                    this.getOnsetExamDataCompleted.emit(null);
                });
    }

    postOnsetExamResult(token: string, onsetExamResultDto: OnsetExamResultDto) {
        // TODO send result to backend
        this.httpClient
            .post<OnsetExamResultDto>(environment.apiUrl + 'idas' + '/' + 'onset' + '/' + token + '/' + 'results', onsetExamResultDto)
            .subscribe((res: OnsetExamResultDto) => { this.postOnsetExamResultCompleted.emit(res); },
                (err: HttpErrorResponse) => {
                    console.log(err.error);
                    console.log(err.name);
                    console.log(err.message);
                    console.log(err.status);
                });
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error);
            console.log(`${operation} failed: ${error.message}`);
            return of(result as T);
        };
    }
}

